import React, { createContext, useContext, useState, useCallback } from 'react';

const CartContext = createContext(null);

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);

  const addItem = useCallback((sphere) => {
    setItems((prev) => [...prev, { ...sphere, cartId: `cart-${Date.now()}-${Math.random().toString(36).substr(2, 9)}` }]);
  }, []);

  const removeItem = useCallback((cartId) => {
    setItems((prev) => prev.filter((item) => item.cartId !== cartId));
  }, []);

  const updateItem = useCallback((cartId, updates) => {
    setItems((prev) =>
      prev.map((item) =>
        item.cartId === cartId ? { ...item, ...updates } : item
      )
    );
  }, []);

  const clearCart = useCallback(() => {
    setItems([]);
  }, []);

  const itemCount = items.length;
  const totalQuantity = items.reduce((sum, item) => sum + (item.quantity || 1), 0);

  return (
    <CartContext.Provider
      value={{
        items,
        addItem,
        removeItem,
        updateItem,
        clearCart,
        itemCount,
        totalQuantity,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
